export default __webpack_public_path__ + "static/media/Master plan hany saad.79cbde80.jpg";